var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentWithCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.9996,
    cy: 38.4,
    r: 38.4,
    fill: "#0094D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4912 31.8916V28.7002H26.1084V31.8916H51.4912ZM51.4912 47.7002V38.2002H26.1084V47.7002H51.4912ZM51.4912 25.5088C52.3818 25.5088 53.124 25.8304 53.7178 26.4736C54.3115 27.0674 54.6084 27.8096 54.6084 28.7002V47.7002C54.6084 48.5908 54.3115 49.3577 53.7178 50.001C53.124 50.5947 52.3818 50.8916 51.4912 50.8916H26.1084C25.2178 50.8916 24.4756 50.5947 23.8818 50.001C23.2881 49.3577 22.9912 48.5908 22.9912 47.7002V28.7002C22.9912 27.8096 23.2881 27.0674 23.8818 26.4736C24.4756 25.8304 25.2178 25.5088 26.1084 25.5088H51.4912Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentWithCard);
export default __webpack_public_path__ + "static/media/paymentWithCard.4af6d63282e24ef08ddd64bf3b51d243.svg";
export { ForwardRef as ReactComponent };